import { deepCopy } from '../utils';

// The driver's own mark: they see their reason and time while it waits to sync.
const setCachedMark = (client, serviceDocketId, mark) => {
	const cacheId = client.cache.identify({ __typename: 'ServiceDocket', id: serviceDocketId });
	if (cacheId) {
		client.cache.modify({ id: cacheId, fields: { couldNotComplete: () => mark } });
	}
};

const getOfflineDocket = ({ variables, queueEntry }) => ({
	__typename: 'ServiceDocket',
	id: variables.serviceDocketId,
	offlineQueuedAt: queueEntry.createdAt,
	offline: true,
});

/**
 * Offline configs for "Couldn't complete this machine" and its Undo on the stop
 * screen. Both replay safely: the server keeps an identical mark and ignores a
 * clear when nothing is marked, and the queue keeps their order.
 */
export const markCouldNotCompleteConfig = {
	serializeVariables: ({ variables }) => deepCopy(variables),
	createMeta: ({ variables, context = {} }) => ({
		type: 'markServiceDocketCouldNotComplete',
		serviceDocketId: variables?.serviceDocketId,
		fallbackMachineName: context.offlineMeta?.machineName || null,
	}),
	applyOptimisticUpdate: async ({ client, variables }) => setCachedMark(client, variables.serviceDocketId, {
		__typename: 'ServiceDocketCouldNotComplete',
		reason: variables.reason,
		at: Date.now(),
		by: null,
	}),
	getOfflineResult: args => ({ markServiceDocketCouldNotComplete: getOfflineDocket(args) }),
};

export const clearCouldNotCompleteConfig = {
	serializeVariables: ({ variables }) => deepCopy(variables),
	createMeta: ({ variables, context = {} }) => ({
		type: 'clearServiceDocketCouldNotComplete',
		serviceDocketId: variables?.serviceDocketId,
		fallbackMachineName: context.offlineMeta?.machineName || null,
	}),
	applyOptimisticUpdate: async ({ client, variables }) => setCachedMark(client, variables.serviceDocketId, null),
	getOfflineResult: args => ({ clearServiceDocketCouldNotComplete: getOfflineDocket(args) }),
};
